module.exports = __webpack_public_path__ + "img/vc.svg";